__turbopack_context__.v({
  "body": "index-module-scss-module__XOuJbq__body",
  "centered": "index-module-scss-module__XOuJbq__centered",
  "withMobileMenu": "index-module-scss-module__XOuJbq__withMobileMenu",
  "withoutFooter": "index-module-scss-module__XOuJbq__withoutFooter",
  "wrapper": "index-module-scss-module__XOuJbq__wrapper",
  "wrapper__withMarginTop": "index-module-scss-module__XOuJbq__wrapper__withMarginTop",
  "wrapper__withMarginTop__hideMobileHeader": "index-module-scss-module__XOuJbq__wrapper__withMarginTop__hideMobileHeader",
  "wrapper__withMarginTop__mainPage": "index-module-scss-module__XOuJbq__wrapper__withMarginTop__mainPage",
});
